export enum InventoryItemDisposition {
  Restock = "restock",
  Liquidate = "liquidate",
  Donate = "donate",
  Dispose = "dispose",
  ReturnToVendor = "return_to_vendor",
}
